import api from './api';

const companyCityService = {
  async list({ activeOnly = true } = {}) {
    return api.get('/company-cities', {
      params: { active_only: activeOnly ? 'true' : 'false' }
    });
  },

  async create(payload) {
    return api.post('/company-cities', payload);
  }
};

export default companyCityService;
